<template>
	<!-- <div class="course-container" > -->

		<!-- coursePt -->
		
		<div id="app">
			<div :class="[{'study-design-width':isStudyDesign},{'course-width':$route.query.belong == 'course' && $route.path.includes('TaskStatic')}]">
				<keep-alive>  
					<router-view v-if="$route.meta.keepAlive" :Platform="Platform" />
				</keep-alive>
				<router-view v-if="!$route.meta.keepAlive" :Platform="Platform" />
			</div>
		</div>
	<!-- </div> -->

</template>

<script>
import {postMessage} from '../src/assets/js/postMessageApi'
export default {
	name: 'App',
	data(){
		return {
			Platform:{},
		}
	},
	computed:{
		isStudyDesign(){
			let meta = this.$route.meta;
			return meta.origin == 'studyDesign'
		},
		activeScenesImgUrl(){
			return  this.$store.state.activeScenesImgUrl;
		},
	},
	created(){
		let that = this
        this.getNavList(function(platform) {
            that.Platform = platform
		})
		//当被作为iframe嵌入到其他项目时
		window.addEventListener('message',postMessage)
		let data = {name:this.getQueryString('fromOutSite'),role:this.getQueryString('role')}
		this.$store.commit({
			type:'UPDATE_FROMOTHERSITE',
			data:data
		})
		if(this.isValid(data.name)){
			$('body').css('overflow-x','hidden')
		}
	},
	watch:{
		activeScenesImgUrl(val){
			$('body').css({
				'background-image':'url('+val+')'
			})
		},
		// '$route':{
		// 	handler:function(val){
		// 		this.IFrameResize();
		// 	},
		// 	immediate:true,
		// 	deep:true
		// }
	},
	methods:{
		IFrameResize(){
			if(this.getSessionVal('workplace') == 'coursept' && this.getSessionVal('tenEdit') == 'tenEdit'){
				console.log("动态修改高度")
				//同域名下动态修改高度
				// let obj = parent.document.getElementById("childFrame"); 
				// let obj = parent.document.getElementById("childFrame"); 
				// obj.height = this.document.body.scrollHeight; 
				this.$nextTick(()=>{
					setTimeout(()=>{
						console.log($('#app').height())
						let obj = {
							eventName:'changeIframeHeight',
							value:$('#app').height()
						}
						window.parent.postMessage(obj,'*')
					},1000)
				})			
			}
		},
		getQueryString(name) {
			let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			let r = window.location.search.substr(1).match(reg);
			if (r != null) {
				return unescape(r[2]);
			};
			return null;
		}
	},
}
</script>

<style>
	@import './assets/css/skin/skin.css';

	body {
		background-repeat: no-repeat;
		background-position: center;
		background-size: 100% 100%;
		background-attachment: fixed;
		padding: none;
		margin: 0!important;
		height: 100vh;
		/* background: none!important; */
		background-color: rgb(247,248,250) !important;
		overflow: auto;
		-webkit-overflow-scrolling: unset;
	}
	
	#app {
		position: relative;
		height: 100%;
		margin: 0 auto;
		/* height: 100vh !important; */
		/* overflow: auto; */
	}
	html /deep/ .el-notification__content{
		margin: 0;
	}
	#app>div{
		height:100%
	}
	.study-design-width{
		width: 80%;
		margin: 0 auto;
	}
	.course-width{
		width: 100% !important;
	}
	@media screen and (max-width: 1400px){
		.study-design-width{
			width: 100%;
		}
	}

</style>



// WEBPACK FOOTER //
// src/App.vue